






































import Vue from 'vue';


export default Vue.extend({
  props: {
    value: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    textProps: {
      type: Object,
      default: () => ({}),
    },
    pickerProps: {
      type: Object,
      default: () => ({}),
    },
    menuProps: {
      type: Object,
      default: () => ({
        closeOnContentClick: false,
        offsetY: true,
        maxWidth: '300',
      }),
    },
  },
  data: () => ({
    menu: false,
    colorValue: '',
  }),
  computed: {
    textValue: {
      get(): string | undefined {
        return this.value || undefined;
      },
      set(value: string) {
        if (value === null) {
          this.colorValue = '';
        }
        this.input(value);
      },
    },
    colorModel: {
      get(): string | undefined {
        return this.colorValue || this.value || undefined;
      },
      set(color: any) {
        this.colorValue = color ? color.hex ? color.hex : color : undefined;
      },
    },
  },
  methods: {
    ok() {
      if (this.colorValue) {
        this.input(this.colorValue);
      }
      this.menu = false;
    },
    cancel()  {
      this.colorValue = '';
      this.menu = false;
    },
    input(value: string) {
      this.$emit('input', value);
    },
    clear() {
      this.$emit('click:clear');
    },
  },
});
